import React, { Component } from 'react';
import { Container, Row, Col, Card } from 'reactstrap';

export class GallerySection extends Component {
  static displayName = GallerySection.name;

  // Placeholder images - en producción se cargarían desde el backend
  galleryImages = [
    {
      id: 1,
      src: "/images/gallery/DSC_0769.JPG",
      alt: "Culto Principal",
      title: "Cultos Dominicales"
    },
    {
      id: 2,
      src: "/images/gallery/jovenes.jpg",
      alt: "Grupo de Jóvenes",
      title: "Grupo de Jóvenes"
    },
    {
      id: 3,
      src: "/images/gallery/DSC_0841.JPG",
      alt: "Eventos Especiales",
      title: "Eventos Especiales"
    },
    {
      id: 4,
      src: "/images/gallery/parejas2.jpg",
      alt: "Comunidad",
      title: "Comunidad"
    },
    {
      id: 5,
      src: "/images/gallery/parejas3.jpg",
      alt: "Grupos de Parejas",
      title: "Grupos de Parejas"
    },
    {
      id: 6,
      src: "/images/gallery/tamborineras.jpg",
      alt: "Renovadas - Congreso de Mujeres",
      title: "Renovadas - Congreso de Mujeres"
    }
  ];

  render() {
    return (
      <section id="gallery" className="section">
        <Container>
          <h2 className="section-title">Galería</h2>
          <Row>
            {this.galleryImages.map((image) => (
              <Col lg="4" md="6" className="mb-4" key={image.id}>
                <Card className="gallery-item">
                  <div className="position-relative">
                    <img 
                      src={image.src} 
                      alt={image.alt}
                      className="card-img-top"
                      style={{ height: '250px', objectFit: 'cover' }}
                    />
                    <div 
                      className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                      style={{ 
                        background: 'rgba(0,0,0,0.5)',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => e.target.style.opacity = '1'}
                      onMouseLeave={(e) => e.target.style.opacity = '0'}
                    >
                      <h5 className="text-white text-center mb-0">
                        {image.title}
                      </h5>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    );
  }
}
